import Vue from 'vue'
import Router from 'vue-router'
import Login from "../pages/Login";
import DeptSelect from '../pages/deptSelect/DeptSelect';
import home from '../pages/home/home';
import DeptList from "../pages/dept/List"
import CreateDept from "../pages/dept/Create"
import UpdateDept from "../pages/dept/Update"
import MemberList from "../pages/member/MemberList";
import CreateMember from "../pages/member/CreateMember";
import BasicInfo from "../pages/member/memberInfo/BasicInfo";
import WorkInfo from "../pages/member/memberInfo/WorkInfo";
import PatentInfo from "../pages/member/memberInfo/PatentInfo";
import PaperInfo from "../pages/member/memberInfo/PaperInfo";
import AchiInfo from "../pages/member/memberInfo/AchiInfo";
import SubjectInfo from "../pages/member/memberInfo/SubjectInfo";
import HonorInfo from "../pages/member/memberInfo/HonorInfo";
import MemberApprove from "../pages/user/MemberApprove";
import TalentInfo from "../pages/member/memberInfo/TalentInfo";
import TeacherInfo from "../pages/member/memberInfo/TeacherInfo";
import StudyInfo from "../pages/member/memberInfo/StudyInfo";
import TeachingInfo from "../pages/member/memberInfo/TeachingInfo";
import GcpInfo from "../pages/member/memberInfo/GcpInfo";
import AwardInfo from "../pages/member/memberInfo/AwardInfo";
import AppointmentInfo from '../pages/member/memberInfo/Appointment';
import GraduateInfo from '../pages/member/memberInfo/GraduateInfo';
import MeetingInfo from '../pages/member/memberInfo/MeetingInfo';
import TrainingInfo from '../pages/member/memberInfo/TrainingInfo';
import LectureInfo from '../pages/member/memberInfo/LectureInfo';
import VolunteerInfo from '../pages/member/memberInfo/VolunteerInfo';
import StudioInfo from '../pages/member/memberInfo/StudioInfo';
import GuideInfo from "../pages/member/memberInfo/GuideInfo";
import CenterInfo from "../pages/member/memberInfo/CenterInfo";
import ArticleInfo from "../pages/member/memberInfo/ArticleInfo";
import Lecture2Info from '../pages/member/memberInfo/Lecture2Info';
import AllianceInfo from '../pages/member/memberInfo/AllianceInfo';
import QualityInfo from '../pages/member/memberInfo/QualityInfo';
import BasicViewInfo from "../components/member/BasicViewInfo";
import MyInfoView from "../pages/myInfo/MyInfoView";
import MyInfoUpdate from "../pages/myInfo/MyInfoUpdate";
import UCenter from "../pages/user/UCenter";
import Password from "../pages/user/Password";
import GroupInvite from "../pages/user/GroupInvite";
import MyInfo from "../pages/user/MyInfo";
import OtherInfo from "../pages/user/OtherInfo";
import Article from "../pages/user/Article";
import ApplyNotice from "../pages/user/ApplyNotice";
import MemberDepartment from "../pages/member/MemberDepartment"
import MemberDepartmentUpdate from "../pages/member/MemberDepartmentUpdate"
import InviteList from '../pages/user/group/InviteList'
import ApproveCenter from '../pages/user/ApproveCenter'
import CaseShareList from '../pages/article/CaseShareList'
import TriangleList from "../pages/article/TriangleList";
import LoudSpeakerList from "../pages/article/LoudSpeakerList";
import ForumList from "../pages/forum/ForumList";
import Main from '../pages/home/Main'
import PendingItemsList from "../pages/pendingItems/PendingItemsList";
import AddressBookList from "../pages/addressBook/AddressBookList";
import PrivatePlotList from "../pages/privateplot/PrivatePlotList";
import AchievementList from "../pages/privateplot/AchievementList";
import MemberData from "../pages/privateplot/MemberData";
import PaperList from "../pages/privateplot/PaperList";
import PasswordBoxList from "../pages/safebox/PasswordBoxList";
import PhotoList from "../pages/safebox/PhotoList";
import ForumDetail from "../pages/forum/detail/ForumDetail"
import PartyBuildList from "../pages/activity/PartyBuildList";
import ActivityList from "../pages/activity/ActivityList";
import CaseShareDetail from "../pages/article/CaseShareDetail"
import AblumList from "../pages/ablum/AblumList"
import LifeAblumList from "../pages/ablum/LifeAblumList"
import LibraryList from "../pages/library/LibraryList";
import LibraryDataList from "../pages/library/LibraryDataList";
import CertificateList from "../pages/certificate/CertificateList";
import ServiceList from "../pages/certificate/ServiceList";
import Basic from "../components/memberData/memberBasic/Basic";
import Learning2 from "../components/memberData/memberBasic/learning/Education";
import Working from "../components/memberData/memberBasic/Working";
import Certificate from "../components/memberData/memberBasic/Certificate";
import MemberPaper from "../components/memberData/memberAchievements/MemberPaper";
import MemberSubject from "../components/memberData/memberAchievements/MemberSubject";
import MemberGcp from "../components/memberData/memberAchievements/MemberGcp";
import MemberWork from "../components/memberData/memberAchievements/MemberWork";
import MemberPatent from "../components/memberData/memberAchievements/MemberPatent";
import MemberAward from "../components/memberData/memberAchievements/MemberAward";
import CountTeaching from "../components/memberData/memberTeaching/CountTeaching";
import Teacher from "../components/memberData/memberTeaching/Teacher";
import Teaching from "../components/memberData/memberTeaching/Teaching";
import MemberOperation from "../components/memberData/memberCompetence/MemberOperation";
import MemberTechniques from "../components/memberData/memberCompetence/MemberTechniques";
import Admitted from "../components/memberData/memberCompetence/Admitted";
import Outpatient from "../components/memberData/memberCompetence/Outpatient";
import MDTCase from "../components/memberData/memberCompetence/MDTCase";
import SocialPosts from "../components/memberData/memberSocialInfluence/SocialPosts";
import VolunteerActivities from "../components/memberData/memberSocialInfluence/VolunteerActivities";
import PopularScience from "../components/memberData/memberSocialInfluence/PopularScience";
import Meeting from "../components/memberData/memberSocialInfluence/Meeting";
import Consultation from "../components/memberData/memberSocialInfluence/Consultation";
import Support from "../components/memberData/memberSocialInfluence/Support";
import PartyConstruction from "../components/memberData/memberSocialInfluence/PartyConstruction";
import FamousDoctorStudio from "../components/memberData/memberSocialInfluence/FamousDoctorStudio";
import Standardization from "../components/memberData/memberAchievements/Standardization";
import PersonalHonoraryTitle from "../components/memberData/memberBasic/PersonalHonoraryTitle";
import CollegeBaseCentre from "../components/memberData/memberSocialInfluence/CollegeBaseCentre";
import MainCopy from '../pages/home/MainCopy'
import ArticleSearch from "../pages/article/ArticleSearch";
import EducationList from "../pages/privateplot/memberDataList/memberBasic/EducationList"
import StudyList from "../pages/privateplot/memberDataList/memberBasic/StudyList"
import AbroadList from "../pages/privateplot/memberDataList/memberBasic/AbroadList"
import TeacherList from "../pages/privateplot/memberDataList/memberBasic/TeacherList"
import Learning from "../components/memberData/memberBasic/Learning";
import WorkingList from "../pages/privateplot/memberDataList/memberBasic/WorkingList";
import JobList from "../pages/privateplot/memberDataList/memberBasic/JobList";
import YSCList from "../pages/privateplot/memberDataList/memberBasic/YSCList";
import YSMList from "../pages/privateplot/memberDataList/memberBasic/YSMList";
import JSCList from "../pages/privateplot/memberDataList/memberBasic/JSCList";
import MemberPaperList from "../pages/privateplot/memberDataList/memberAchievements/MemberPaperList";
import MemberSubjectList from "../pages/privateplot/memberDataList/memberAchievements/MemberSubjectList";
import MemberGCPList from "../pages/privateplot/memberDataList/memberAchievements/MemberGCPList";
import MemberWorkList from "../pages/privateplot/memberDataList/memberAchievements/MemberWorkList";
import MemberPatentList from "../pages/privateplot/memberDataList/memberAchievements/MemberPatentList";
import MemberAwardList from "../pages/privateplot/memberDataList/memberAchievements/MemberAwardList";
import MemberManage from  "../pages/user/MemberManage.vue";
import MemberRoleManage from  "../pages/user/MemberRoleManage.vue";
import MemberRoleUpdate from  "../pages/user/MemberRoleUpdate.vue";
import MemberTeacherList from "../pages/privateplot/memberDataList/memberTeaching/MemberTeacherList";
import MemberTeachingList from "../pages/privateplot/memberDataList/memberTeaching/MemberTeachingList";
import MemberOperationList from "../pages/privateplot/memberDataList/memberCompetence/MemberOperationList";
import MemberTechniquesList from "../pages/privateplot/memberDataList/memberCompetence/MemberTechniquesList";
import AdmittedList from "../pages/privateplot/memberDataList/memberCompetence/AdmittedList";
import OutpatientList from "../pages/privateplot/memberDataList/memberCompetence/OutpatientList";
import MDTCaseList from "../pages/privateplot/memberDataList/memberCompetence/MDTCaseList";
import MemberSocialPostList from "../pages/privateplot/memberDataList/memberSocialInfluence/MemberSocialPostList";
import VolunteerActivitiesList from "../pages/privateplot/memberDataList/memberSocialInfluence/VolunteerActivitiesList";
import PopularScienceList from "../pages/privateplot/memberDataList/memberSocialInfluence/PopularScienceList";
import MeetingList from "../pages/privateplot/memberDataList/memberSocialInfluence/MeetingList";
import FamousDoctorStudioList from "../pages/privateplot/memberDataList/memberSocialInfluence/FamousDoctorStudioList";
import ConsultatiionList from "../pages/privateplot/memberDataList/memberSocialInfluence/ConsultatiionList";
import PersonalHonoraryTitleList from "../pages/privateplot/memberDataList/memberSocialInfluence/PersonalHonoraryTitleList";
import PartyConstructionList from "../pages/privateplot/memberDataList/memberSocialInfluence/PartyConstructionList";
import StandardizationList from "../pages/privateplot/memberDataList/memberSocialInfluence/StandardizationList";
import CollegeBaseCentreList from "../pages/privateplot/memberDataList/memberSocialInfluence/CollegeBaseCentreList";
import SupportList from "../pages/privateplot/memberDataList/memberSocialInfluence/SupportList";
Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Login',
      component: Login
    },
    {
      path: '/deptSelect',
      name: 'deptSelect',
      component: DeptSelect
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      redirect:"/dashboard",
      children: [
        {
          path: '/back',
          name: 'Main',
          component: Main
        },
        {
          path: '/dashboard',
          name: 'MainCopy',
          component: MainCopy
        },
        {
          path: '/user/list',
          name: 'MemberList',
          component: MemberList
        },
        {
          path: '/user/organization',
          name: 'MemberDepartment',
          component: MemberDepartment
        },
        {
          path: '/user/organization/update',
          name: 'MemberDepartmentUpdate',
          component: MemberDepartmentUpdate
        },
        {
          path: '/user/create',
          name: 'CreateMember',
          component: CreateMember,
          redirect: '/user/info/basic',
          children: [
            {
              path: '/user/info/basic',
              name: 'BasicInfo',
              component: BasicInfo
            },
            {
              path: '/user/info/basicView',
              name: 'BasicViewInfo',
              component: BasicViewInfo
            },
            {
              path: '/user/info/work',
              name: 'WorkInfo',
              component: WorkInfo
            },
            {
              path: '/user/info/patent',
              name: 'PatentInfo',
              component: PatentInfo
            },
            {
              path: '/user/info/paper',
              name: 'PaperInfo',
              component: PaperInfo
            },
            {
              path: '/user/info/achi',
              name: 'AchiInfo',
              component: AchiInfo
            },
           {
              path: '/user/info/subject',
              name: 'SubjectInfo',
              component: SubjectInfo
            },
            {
              path: '/user/info/teaching',
              name: 'TeachingInfo',
              component: TeachingInfo

            },
            {
              path: '/user/info/gcp',
              name: 'GcpInfo',
              component: GcpInfo

            },
            {
              path: '/user/info/award',
              name: 'AwardInfo',
              component: AwardInfo
            },
            {
              path: '/user/info/honor',
              name: 'HonorInfo',
              component: HonorInfo
            },
            {
              path: '/user/info/talent',
              name: 'TalentInfo',
              component: TalentInfo
            },
            {
              path: '/user/info/teacher',
              name: 'TeacherInfo',
              component: TeacherInfo
            },
            {
              path: '/user/info/study',
              name: 'StudyInfo',
              component: StudyInfo
            },
            {
              path: '/user/info/appointment',
              name: 'AppointmentInfo',
              component: AppointmentInfo
            },
            {
              path: '/user/info/graduate',
              name: 'GraduateInfo',
              component: GraduateInfo
            },
            {
              path: '/user/info/meeting',
              name: 'MeetingInfo',
              component: MeetingInfo
            },
            {
              path: '/user/info/training',
              name: 'TrainingInfo',
              component: TrainingInfo
            },
            {
              path: '/user/info/lecture',
              name: 'LectureInfo',
              component: LectureInfo
            },
            {
              path: '/user/info/volunteer',
              name: 'VolunteerInfo',
              component: VolunteerInfo
            },
            {
              path: '/user/info/studio',
              name: 'StudioInfo',
              component: StudioInfo
            },
            {
              path: '/user/info/guide',
              name: 'GuideInfo',
              component: GuideInfo
            },
            {
              path: '/user/info/center',
              name: 'CenterInfo',
              component: CenterInfo
            },
            {
              path: '/user/info/article',
              name: 'ArticleInfo',
              component: ArticleInfo
            },
            {
              path: '/user/info/lecture2',
              name: 'Lecture2Info',
              component: Lecture2Info
            },
            {
              path: '/user/info/quality',
              name: 'QualityInfo',
              component: QualityInfo
            },
            {
              path: '/user/info/alliance',
              name: 'AllianceInfo',
              component: AllianceInfo
            }
          ]
        },
        {
          path: '/myself/info/view',
          name: 'MyInfoView',
          component: MyInfoView
        },
        {
          path: '/myself/info/update',
          name: 'MyInfoUpdate',
          component: MyInfoUpdate
        },
        {
          path: '/uCenter/info',
          name: 'uCenter',
          component: UCenter,
          redirect: '/uCenter/myInfo',
          children: [{
            path: '/uCenter/myInfo',
            name: 'MyInfo',
            component: MyInfo,
          },
            {
              path: '/uCenter/otherInfo',
              name: 'OtherInfo',
              component: OtherInfo,
            },
            {
            path: '/uCenter/password',
            name: 'Password',
            component: Password,
          },{
            path: '/uCenter/article',
            name: 'Article',
            component: Article,
          },{
            path: '/uCenter/inviteList',
            name: 'inviteList',
            component: InviteList,
          }, {
            path: '/uCenter/approve',
            name: 'ApproveCenter',
            component: ApproveCenter
          },{
            path: '/uCenter/applyNotice',
            name: 'ApplyNotice',
            component: ApplyNotice
          },  {
            path: '/organization/list',
            name: 'DeptList',
            component: DeptList
          }, {
              path: '/organization/create',
              name: 'CreateDept',
              component: CreateDept,
            }, {
              path: '/organization/update',
              name: 'UpdateDept',
              component: UpdateDept
            }, {
              path: '/user/approve',
              name: 'MemberApprove',
              component: MemberApprove
            },
            {
              path: '/user/manage',
              name: 'MemberManage',
              component: MemberManage
            },
            // {
            //   path: '/user/provinManage',
            //   name: 'SzyMemberManage',
            //   component: SzyMemberManage
            // },
            {
              path: '/user/role/manage',
              name: 'MemberRoleManage',
              component: MemberRoleManage
            },{
              path: '/user/role/update',
              name: 'MemberRoleUpdate',
              component: MemberRoleUpdate
            },
          ]
        },
        {
          path: '/uCenter/inviteList',
          name: 'InviteList',
          component: InviteList
        },
        {
          path: '/caseShare/list',
          name: 'CaseShareList',
          component: CaseShareList
        },
        {
          path: '/article/LoudSpeakerList',
          name: 'LoudSpeakerList',
          component: LoudSpeakerList
        }, {
          path: '/article/TriangleList',
          name: 'TriangleList',
          component: TriangleList,

        },
        {
          path: "/article/articleSearch",
          name: 'ArticleSearch',
          component: ArticleSearch
        },
        {
          path:'/pendingItems/list',
          name: 'PendingItemsList',
          component: PendingItemsList
        },{
          path: '/forum/list',
          name: 'ForumList',
          component: ForumList
        },
        {
          path: '/addressBook/list',
          name: 'AddressBookList',
          component: AddressBookList
        },{
          path: '/privateplot/PrivatePlotList',
          name: 'PrivatePlotList',
          component: PrivatePlotList
        },{
          path: '/privateplot/AchievementList',
          name: 'AchievementList',
          component: AchievementList
        },
        {
          path: '/privateplot/member',
          name: 'MemberData',
          component: MemberData,
          redirect: '/privateplot/member',
          children: [
            //基本信息
            {
              path: '/privateplot/member/basic',
              name: 'Basic',
              component: Basic,
            },
            {
              path: '/privateplot/member/learning',
              name: 'Learning',
              component: Learning,
            },
            {
              path: '/privateplot/member/working',
              name: 'Working',
              component: Working,
            },
            {
              path: '/privateplot/member/certificate',
              name: 'Certificate',
              component: Certificate,
            },
            //科研成果
            {
              path: '/privateplot/member/paper',
              name: 'MemberPaper',
              component: MemberPaper
            },
            {
              path: '/privateplot/member/subject',
              name: 'MemberSubject',
              component: MemberSubject
            },
            {
              path: '/privateplot/member/gcp',
              name: 'MemberGcp',
              component: MemberGcp
            },
            {
              path: '/privateplot/member/work',
              name: 'MemberWork',
              component: MemberWork
            },
            {
              path: '/privateplot/member/patent',
              name: 'MemberPatent',
              component: MemberPatent
            },
            {
              path: '/privateplot/member/award',
              name: 'MemberAward',
              component: MemberAward
            },
            //教学
            {
              path: '/privateplot/member/countTeaching',
              name: 'CountTeaching',
              component: CountTeaching
            },
            {
              path: '/privateplot/member/teacher',
              name: 'Teacher',
              component: Teacher
            },
            {
              path: '/privateplot/member/teaching',
              name: 'Teaching',
              component: Teaching
            },
            //临床能力
            {
              path: '/privateplot/member/operation',
              name: 'MemberOperation',
              component: MemberOperation
            },
            {
              path: '/privateplot/member/techniques',
              name: 'MemberTechniques',
              component: MemberTechniques
            },
            {
              path: '/privateplot/member/admitted',
              name: 'Admitted',
              component: Admitted
            },
            {
              path: '/privateplot/member/outpatient',
              name: 'Outpatient',
              component: Outpatient
            },
            {
              path: '/privateplot/member/mdtCase',
              name: 'MDTCase',
              component: MDTCase
            },
            //社会影响力
            {
              path: '/privateplot/member/socialPosts',
              name: 'SocialPosts',
              component: SocialPosts
            },
            {
              path: '/privateplot/member/volunteerActivities',
              name: 'VolunteerActivities',
              component: VolunteerActivities
            },
            {
              path: '/privateplot/member/popularScience',
              name: 'PopularScience',
              component: PopularScience
            },
            {
              path: '/privateplot/member/meeting',
              name: 'Meeting',
              component: Meeting
            },
            {
              path: '/privateplot/member/consultation',
              name: 'Consultation',
              component: Consultation
            },
            {
              path: '/privateplot/member/support',
              name: 'Support',
              component: Support
            },
            {
              path: '/privateplot/member/partyConstruction',
              name: 'PartyConstruction',
              component: PartyConstruction
            },
            {
              path: '/privateplot/member/famousDoctorStudio',
              name: 'FamousDoctorStudio',
              component: FamousDoctorStudio
            },
            {
              path: '/privateplot/member/standardization',
              name: 'Standardization',
              component: Standardization
            },
            {
              path: '/privateplot/member/personalHonoraryTitle',
              name: 'PersonalHonoraryTitle',
              component: PersonalHonoraryTitle
            },
            {
              path: '/privateplot/member/collegeBaseCentre',
              name: 'CollegeBaseCentre',
              component: CollegeBaseCentre
            },
        ]
        },
        {
          path: '/privateplot/PaperList',
          name: 'PaperList',
          component: PaperList
        }, {
          path: '/safebox/passwordboxlist',
          name: 'PasswordBoxList',
          component: PasswordBoxList
        },
        {
          path: '/safebox/photoList',
          name: 'PhotoList',
          component: PhotoList
        }, {
          path: '/forum/detail',
          name: 'ForumDetail',
          component: ForumDetail
        }, {
          path: '/activity/ActivityList',
          name: 'ActivityList',
          component: ActivityList
        }, {
          path: '/activity/PartyBuildList',
          name: 'PartyBuildList',
          component: PartyBuildList
        }, {
          path: '/caseShare/view',
          name: 'CaseShareDetail',
          component: CaseShareDetail
        },
        {
          path: '/ablum/AblumList',
          name: 'AblumList',
          component: AblumList
        },
        {
          path: '/ablum/LifeAblumList',
          name: 'LifeAblumList',
          component: LifeAblumList
        },
        {
          path: '/library/LibraryList',
          name: 'LibraryList',
          component: LibraryList
        },
        {
          path: '/library/LibraryDataList',
          name: 'LibraryDataList',
          component: LibraryDataList
        },
        {
          path: '/certificate/CertificateList',
          name: 'CertificateList',
          component: CertificateList
        },
        {
          path: '/certificate/ServiceList',
          name: 'ServiceList',
          component: ServiceList
        },
        {
          path: '/privateplot/member/education/list',
          name: 'EducationList',
          component: EducationList
        },
        {
          path: '/privateplot/member/study/list',
          name: 'StudyList',
          component: StudyList
        },
        {
          path: '/privateplot/member/abroad/list',
          name: 'AbroadList',
          component: AbroadList
        },
        {
          path: '/privateplot/member/teacher/list',
          name: 'TeacherList',
          component: TeacherList
        },
        {
          path: '/privateplot/member/working/list',
          name: 'WorkingList',
          component: WorkingList
        },{
          path: '/privateplot/member/job/list',
          name: 'JobList',
          component: JobList
        },{
          path: '/privateplot/member/ysc/list',
          name: 'YSCList',
          component: YSCList
        },{
          path: '/privateplot/member/ysm/list',
          name: 'YSMList',
          component: YSMList
        },{
          path: '/privateplot/member/jsc/list',
          name: 'JSCList',
          component: JSCList
        },
        {
          path: '/privateplot/member/paper/list',
          name: 'MemberPaperList',
          component: MemberPaperList
        },{
          path: '/privateplot/member/subject/list',
          name: 'MemberSubjectList',
          component: MemberSubjectList
        },{
          path: '/privateplot/member/gcp/list',
          name: 'MemberGCPList',
          component: MemberGCPList
        },{
          path: '/privateplot/member/work/list',
          name: 'MemberWorkList',
          component: MemberWorkList
        },{
          path: '/privateplot/member/patent/list',
          name: 'MemberPatentList',
          component: MemberPatentList
        },{
          path: '/privateplot/member/award/list',
          name: 'MemberAwardList',
          component: MemberAwardList
        },{
          path: '/privateplot/member/teachers/list',
          name: 'MemberTeacherList',
          component: MemberTeacherList
        },{
          path: '/privateplot/member/teaching/list',
          name: 'MemberTeachingList',
          component: MemberTeachingList
        },{
          path: '/privateplot/member/operation/list',
          name: 'MemberOperationList',
          component: MemberOperationList
        },{
          path: '/privateplot/member/techniques/list',
          name: 'MemberTechniquesList',
          component: MemberTechniquesList
        },{
          path: '/privateplot/member/admitted/list',
          name: 'AdmittedList',
          component: AdmittedList
        },{
          path: '/privateplot/member/outpatient/list',
          name: 'OutpatientList',
          component: OutpatientList
        },{
          path: '/privateplot/member/mdt/list',
          name: 'MDTCaseList',
          component: MDTCaseList
        },{
          path: '/privateplot/member/SocialPosts/list',
          name: 'MemberSocialPostList',
          component: MemberSocialPostList
        },{
          path: '/privateplot/member/volActiv/list',
          name: 'VolunteerActivitiesList',
          component: VolunteerActivitiesList
        },{
          path: '/privateplot/member/popScience/list',
          name: 'PopularScienceList',
          component: PopularScienceList
        },{
          path: '/privateplot/member/meeting/list',
          name: 'MeetingList',
          component: MeetingList
        },{
          path: '/privateplot/member/famousDoctor/list',
          name: 'FamousDoctorStudioList',
          component: FamousDoctorStudioList
        },{
          path: '/privateplot/member/consultation/list',
          name: 'ConsultatiionList',
          component: ConsultatiionList
        },{
          path: '/privateplot/member/perHon/list',
          name: 'PersonalHonoraryTitleList',
          component: PersonalHonoraryTitleList
        },{
          path: '/privateplot/member/partyConstruction/list',
          name: 'PartyConstructionList',
          component: PartyConstructionList
        },{
          path: '/privateplot/member/standardization/list',
          name: 'StandardizationList',
          component: StandardizationList
        },{
          path: '/privateplot/member/colBaseCen/list',
          name: 'CollegeBaseCentreList',
          component: CollegeBaseCentreList
        },{
          path: '/privateplot/member/support/list',
          name: 'SupportList',
          component: SupportList
        },
      ]
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js